import { render, staticRenderFns } from "./SubdistributorEditor.vue?vue&type=template&id=9de1a802"
import script from "./SubdistributorEditor.vue?vue&type=script&lang=js"
export * from "./SubdistributorEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports